import { useState } from "react";
import BaseClient from "../helper/Baseclient";
import { APIEndpoints } from "../constants/APIEndpoints";

const getAuthHeaders = () => {
  const token = window.localStorage.getItem("UserRetention");
  if (!token) return null;
  return { Authorization: `Bearer ${token}` };
};

const normalizeTables = (res) => {
  const data = res?.data ?? res;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.diningTables)) return data.diningTables;
  if (Array.isArray(data?.tables)) return data.tables;
  if (Array.isArray(data?.tableList)) return data.tableList;
  if (Array.isArray(data?.list)) return data.list;
  return [];
};

const useDiningTables = () => {
  const [diningTables, setDiningTables] = useState([]);
  const [diningTablesLoading, setDiningTablesLoading] = useState(false);

  const fetchDiningTables = async () => {
    const headers = getAuthHeaders();
    if (!headers) {
      console.error("AUTH TOKEN MISSING!");
      return;
    }

    try {
      setDiningTablesLoading(true);
      await BaseClient.get(
        APIEndpoints.diningTablesList,
        {},
        {
          onSuccess: (res) => {
            setDiningTables(normalizeTables(res));
          },
          onFailed: (err) => {
            console.error("Error fetching dining tables", err);
            setDiningTables([]);
          },
          headers,
        }
      );
    } finally {
      setDiningTablesLoading(false);
    }
  };

  const createDiningTable = async (payload, { onSuccess, onFailed } = {}) => {
    const headers = getAuthHeaders();
    if (!headers) {
      onFailed?.({ message: "Authorisation token missing." });
      return;
    }

    try {
      setDiningTablesLoading(true);
      await BaseClient.post(APIEndpoints.diningTablesAdd, payload, {
        onSuccess,
        onFailed,
        headers,
      });
    } finally {
      setDiningTablesLoading(false);
    }
  };

  const updateDiningTable = async (
    id,
    payload,
    { onSuccess, onFailed } = {}
  ) => {
    const headers = getAuthHeaders();
    if (!headers) {
      onFailed?.({ message: "Authorisation token missing." });
      return;
    }
    if (!id) {
      onFailed?.({ message: "Table id is required." });
      return;
    }

    try {
      setDiningTablesLoading(true);
      await BaseClient.put(
        `${APIEndpoints.diningTablesUpdate}/${id}`,
        payload,
        {
          onSuccess,
          onFailed,
          headers,
        }
      );
    } finally {
      setDiningTablesLoading(false);
    }
  };

  const updateDiningTableStatus = async (
    id,
    status,
    { onSuccess, onFailed } = {}
  ) => {
    const headers = getAuthHeaders();
    if (!headers) {
      onFailed?.({ message: "Authorisation token missing." });
      return;
    }
    if (!id) {
      onFailed?.({ message: "Table id is required." });
      return;
    }

    try {
      setDiningTablesLoading(true);
      await BaseClient.put(
        `${APIEndpoints.diningTablesStatus}/${id}`,
        { status },
        {
          onSuccess,
          onFailed,
          headers,
        }
      );
    } finally {
      setDiningTablesLoading(false);
    }
  };

  return {
    diningTables,
    diningTablesLoading,
    fetchDiningTables,
    createDiningTable,
    updateDiningTable,
    updateDiningTableStatus,
  };
};

export default useDiningTables;
